import { createContext, useContext, useEffect, useRef, useState } from 'react';
import { useAuth } from './AuthContext';

const MultipleWebSocketContext = createContext(null);

export const MultipleWebSocketProvider = ({ children }) => {
  const socketsRef = useRef({});
  const [statuses, setStatuses] = useState({});
  const [errors, setErrors] = useState({});
  const { user } = useAuth();

  const connect = (url) => {
    if (!url || !localStorage.getItem('access_token') || socketsRef.current[url]) return;

    const socket = new WebSocket(url);

    socket.onopen = () => {
      console.log(`WebSocket connected: ${url}`);
      setStatuses(prev => ({ ...prev, [url]: 'connected' }));
      setErrors(prev => ({ ...prev, [url]: null }));
    };

    socket.onclose = () => {
      console.log(`WebSocket closed: ${url}`);
      setStatuses(prev => ({ ...prev, [url]: 'disconnected' }));
      // Optional reconnect logic
      if (localStorage.getItem('access_token')) {
        setTimeout(() => connect(url), 5000);
      }
    };

    socket.onerror = (error) => {
      console.error(`WebSocket error (${url}):`, error);
      setStatuses(prev => ({ ...prev, [url]: 'error' }));
      setErrors(prev => ({ ...prev, [url]: 'WebSocket connection error' }));
    };

    socketsRef.current[url] = socket;
  };

  const close = (url) => {
    if (socketsRef.current[url]) {
      socketsRef.current[url].close();
      delete socketsRef.current[url];
    }
  };

  const getSocket = (url) => socketsRef.current[url];

  useEffect(() => {
    return () => {
      Object.values(socketsRef.current).forEach(socket => socket.close());
    };
  }, []);

  useEffect(() => {
    if (!user) {
      Object.values(socketsRef.current).forEach(socket => socket.close());
      socketsRef.current = {};
      setStatuses({});
      setErrors({});
    }
  }, [user]);

  return (
    <MultipleWebSocketContext.Provider value={{ connect, close, getSocket, statuses, errors }}>
      {children}
    </MultipleWebSocketContext.Provider>
  );
};

export const useMultipleWebSocket = () => useContext(MultipleWebSocketContext);
